<template>
  <div class="basic-setting-content pl16 pr16">
    <!--价格政策-->
    <div class="common-form">价格政策</div>

    <el-form-item label="价格规格：" :rules="[{ required: true, message: '请选择价格规格' }]">
      <template slot="label">
            <span>价格规格
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>单规格，所有称重类型共用一套价格计算逻辑</p>
                  <p>多规格，每一种称重类型不同的价格计算逻辑</p>
                </div>
              </el-tooltip>
            </span>
      </template>
      <el-radio-group v-model="form.model.specType" @input="specTypeChange" :disabled="scene ==='add'||scene ==='copy'">
        <el-radio :label="10" v-if="!form.isSpecLocked||(form.isSpecLocked&&form.model.specType==10)">单规格</el-radio>
        <el-radio :label="20" v-if="(!form.isSpecLocked||(form.isSpecLocked&&form.model.specType==20))">多规格</el-radio>
      </el-radio-group>
      <div v-if="form.isSpecLocked" class="red">此商品正在参加活动，不能修改规格</div>
      <div v-if="form.model.specType==20" disabled class="red">多规格价格政策时，单次称重和两次称重都需要设置计费信息
      </div>
    </el-form-item>

    <el-form-item label="称重类型" :rules="[{ required: true, message: '请选择称重类型' }]"
                  v-if="form.model.specType == 20">
      <el-radio-group v-model="weightType" @input="weightTypeChange">
        <el-radio :label="1">单次称重</el-radio>
        <el-radio :label="2">两次称重</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="计算方式：" :rules="[{ required: true, message: '请选择计算方式' }]">
      <el-radio-group v-model="model.stageType" :disabled="scene ==='add'||scene ==='copy'">
        <el-radio :label="10" v-if="!form.isSpecLocked||(form.isSpecLocked&&model.stageType==10)">固定价格
        </el-radio>
        <el-radio :label="20" v-if="!form.isSpecLocked||(form.isSpecLocked&&model.stageType==20)">阶梯价格
        </el-radio>
        <el-radio :label="30" v-if="!form.isSpecLocked||(form.isSpecLocked&&model.stageType==30)">倍数价格
        </el-radio>
      </el-radio-group>
      <div v-if="form.isSpecLocked" class="red">此设备正在参加活动，不能修改规格</div>
    </el-form-item>

    <!--固定价格-->
    <template v-if="model.stageType == 10">
      <Fixed :model="model"></Fixed>
      <div class="common-form">固定价格计算描述</div>
      <div slot="content">
        <p style="color: red">按次收费，单次的价格</p>
        <p>例子:</p>
        <p>设置产品价格1元,则每次收费固定为1元，与重量没有关系</p>
      </div>
    </template>

    <!--阶梯价格-->
    <template v-if="model.stageType == 20">
      <Stage :model="model"></Stage>
      <div class="common-form">阶梯价格计算描述</div>
      <div slot="content">
        <p style="color: red">按重量阶梯收费，每行重量值为最小重量,且包含该值</p>
        <p>例子:</p>
        <div class="logo">
          <img :alt="3" :src="logoImg_url">
        </div>
      </div>
    </template>

    <template v-if="model.stageType == 30">
      <Multiple :model="model"></Multiple>
      <div class="common-form">倍数价格计算描述</div>
      <div slot="content">
        <p style="color: red">按重量(单位kg) x 产品价格收费</p>
        <p>例子:</p>
        <p>设置产品价格1元,当前重量为1吨,则每次收费=1000 x 1</p>
      </div>
    </template>

  </div>
</template>

<script>
import Fixed from './priceStage/Fixed.vue';
import Stage from './priceStage/Stage.vue';
import Multiple from './priceStage/Multiple.vue';
import logoImg from '@/assets/img/price_stage_des.png';
import PorductApi from '@/api/product.js';
import moment from "moment/moment";

export default {
  components: {
    /*固定价格*/
    Fixed,
    /*阶梯价格*/
    Stage,
    Multiple
  },
  data() {
    return {
      /*背景图片*/
      weightType: 1,
      specType: 10,
      logoImg_url: logoImg,
      model: {
        stageType: 10
      }
    }
  },
  props: ['scene'],
  inject: ['form'],
  created() {
    // this.weightTypeChange(1)
    this.specTypeChange(this.form.model.specType)
  },
  methods: {
    specTypeChange(e) {
      let self = this;
      if (e === 10) {
        self.model = self.form.model.sku[0] || self.form.model.sku;
      } else if (e === 20) {
        let Params = {
          productId: self.form.model.id,
        };
        PorductApi.addProductSpec(Params, true)
          .then(res => {
            self.form.model.specMany.specAttr = [res.data];
            //如果多规格为空，则新建
            let specAttr = self.form.model.specMany.specAttr[0].specItems.filter(child => {
              //返回每一项的子级数组
              return self.weightType + '' === child.specValue
            });

            let branchArr = self.form.model.specMany.specList.filter(child => {
              //返回每一项的子级数组
              return self.weightType === child.specForm.weightType && child.specSkuId !== '0'
            });
            if (branchArr.length == 0) {
              let p = {
                productSkuId: 0,
                specSkuId: specAttr[0].itemId,
                specForm: {weightType: self.weightType, stockNum: 100, stageMany: []}
              };
              self.form.model.specMany.specList.push(p)
              branchArr = [p];
            }

            self.model = branchArr[0].specForm;
          })
          .catch(error => {
            specAttr.loading = false;
          });
      }
    },

    weightTypeChange(e) {
      let self = this;
      if (self.form.model.specType === 10) {
        self.model = self.form.model.sku[0] || self.form.model.sku;
      } else if (self.form.model.specType === 20) {
        //如果多规格为空，则新建
        let specAttr = self.form.model.specMany.specAttr[0].specItems.filter(child => {
          //返回每一项的子级数组
          return e + '' === child.specValue
        });

        let branchArr = self.form.model.specMany.specList.filter(child => {
          //返回每一项的子级数组
          return e === child.specForm.weightType && child.specSkuId !== '0'
        });

        if (branchArr.length === 0) {
          let p = {
            productSkuId: 0,
            specSkuId: specAttr[0].itemId,
            specForm: {weightType: e, stockNum: 100, stageMany: []}
          };

          self.form.model.specMany.specList.push(p)
          branchArr = [p];
        }

        self.model = branchArr[0].specForm;
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/PriceStage.vue